import React from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
interface Column {
    title: string;
    dataIndex: string;
    key: string;
    sorter?: any;
    render?: (text: string, record: any) => JSX.Element;
}

interface TableComponentProps {
    columns: Column[];
    data: any[];
    loading?: boolean;
    pageSize: number;
    showSizeChanger: boolean;
    total: number;
    currentPage: number;
    onPageChange?: (page: number, pageSize: number) => void;
    pageSizeOptions?: number[];
}

const TableComponent: React.FC<TableComponentProps> = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <Table
            columns={props.columns}
            dataSource={props.data}
            loading={props?.loading || false}
            pagination={{
                responsive: true,
                showSizeChanger: props.showSizeChanger,
                pageSize: props.pageSize,
                total: props?.total ?? 0,
                current: props?.currentPage ?? 1,
                defaultCurrent: 1,
                onChange: props.onPageChange,
                pageSizeOptions: props.pageSizeOptions, 
                locale: { 
                    items_per_page: `${t('pagination.page')}`, 
                  }
            }} 
            rowKey={(record) => record.id}
            scroll={{ x: 'max-content', y: 330 }}
            />
    );
};

export default TableComponent;
